<template>
<div class="ac-checker js-availability-form">
    <div class="ac-checker-body">
        <div class="ac-checker-form">
            <div class="control-group">
                <label for="guests">Guests</label>
                <GuestsPopup />
            </div>

            <div class="control-group">
                <label for="dates">Check in - Check out</label>
                <CalendarPopup />
            </div>
        </div>

        <div class="ac-notice" role="alert" v-show="$store.state.errorMessageVisible" :class="$store.state.errorMessageClass">
            <span class="ac-notice__icon" aria-hidden="true">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="13"
                    viewBox="0 0 15 13"
                    fill="#ffffff"
                >
                    <path
                        fill="inherit"
                        d="M8.11523 7.75977V5.24023H6.88477V7.75977H8.11523ZM8.11523 10.25V8.99023H6.88477V10.25H8.11523ZM0.615234 12.125L7.5 0.259766L14.3848 12.125H0.615234Z"
                    />
                </svg>
            </span>
            <p class="ac-notice__text">{{$store.state.errorMessageText}}</p>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import GuestsPopup from './GuestsPopup';
import CalendarPopup from './CalendarPopup';

export default {
    name: 'GuestDateSelector',
    components: {
        GuestsPopup,
        CalendarPopup
    },
    data() {
        return {
            isActive: false,
        }
    },
    created() {
        // Check if it is WP env
        if (document.body.classList.contains("single")) {
            this.$store.commit("setPlaceInfo", window.current_place);
            this.$store.dispatch("setGuestInputsState");
        }

        // Make the submit function available globally for other JS
        window.submitEnquiry = this.submitEnquiry.bind(this);
    },
    methods: {
        setCookie: function() {
            this.$store.dispatch('enquiryCookieController');
        },
        submitEnquiry: function() {
            this.$store.dispatch('hideErrorMessage');
            this.setCookie();

            this.$store.dispatch({
                type: 'trackGaEvent',
                eventCategory: 'Availability calendar',
                eventAction: 'Enquiry now clicked',
            });

            return true;
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../assets/styles/toolbox.scss";

    .is-demo {
        .ac-checker {
            position: absolute;
            top: 0;
            @include media(min-width, $bp--app-fixed) {
                right: 0;
                width: rem(352px);

            }
        }
    }

    .ac-checker {
        color: white;
        z-index: 1000 + 10; // keep above everything

        @include media(min-width, $bp--app-fixed) {
            color: #585858;
            z-index: 500;
        }
    }

    .ac-checker-body {
        width: 100%;
        transition: transform 0.3s ease-out, opacity 0.3s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .ac-checker-form {
        flex-grow: 1;
        overflow: scroll;

        @include media(min-width, $bp--app-fixed) {
            overflow: visible;
        }
    }

    label {
        text-transform: uppercase;
        color: #8C8C8C;
        font-size: rem(15px);
        font-weight: 500;
        line-height: 1.2; // 18px
        font-family: Roboto,Helvetica Neue,Helvetica,Arial,sans-serif;
        letter-spacing: 1.21px;
        margin-bottom: .5rem;
    }

    .control-group {
        margin-bottom: 1rem; // 16px
    }

    .ac-checker-error {
        background: #DA6361;
        margin: (- rem(5px)) 0 rem(10px) 0;

        p {
            color: white;
        }

        svg {
            vertical-align: top;
            margin-top: rem(2px);
        }
    }

    .ac-checker-notice {
        background: rgba(246,158,132,1);;
    }
</style>
